export const addExpressPaypalAnalyticsData = ({
  isOrderSummary = false,
  productInfo = {},
}) => {
  const payaplText = "paypal checkout"
  let eventLocation = " preview"
  let linkType = "cart preview"
  let linkZoneName = "cart:preview"
  let linkPosition = "cart preview"

  if (isOrderSummary) {
    eventLocation = ":landing page"
    linkType = "cart"
    linkZoneName = "cart:landing page:order summary"
    linkPosition = "cart"
  }

  const eventInfo = {
    clickInternalLinks: "false",
    eventAction: `cart${eventLocation}:${payaplText}`,
    eventName: `cart${eventLocation}:${payaplText}`,
    eventType: "navigation",
    internalLinkName: payaplText,
    internalLinkPosition: linkPosition,
    internalLinkType: `${linkType}:navigation`,
    internalLinkUrl: "n/a",
    internalLinkZoneName: linkZoneName,
  }
  pushAnalyticsObjToDataLayer({ productInfo, eventInfo })
}
const pushAnalyticsObjToDataLayer = ({ eventInfo = {}, productInfo }) => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = getState ? getState("page") : {}
  const event = "cmp:click"
  let objDJ = { event, eventInfo, page }
  if (Object.keys(productInfo).length !== 0) {
    objDJ = { ...objDJ, productInfo }
  }
  window.adobeDataLayer.push(objDJ)
}
